// ============================================================================
// Forms — shared AJAX submit helper (.js-formSubmit) with reCAPTCHA v3 + notyf
// Backend JSON: success { err:false, msg, redirect, reload, cart, target, html }
//               error   { err:true,  msg, fields:[...] }
// Custom hooks: call submitForm(trigger, onSuccess, onError) directly.
// ============================================================================
(function ($) {
    'use strict';

    const notyf = (typeof window.Notyf !== 'undefined')
        ? new window.Notyf({
            duration: 4000,
            position: { x: 'right', y: 'top' },
            dismissible: true,
        })
        : {
            success: (msg) => { console.log('[notyf.success]', msg); },
            error:   (msg) => { console.warn('[notyf.error]', msg); },
        };
    window.notyf = notyf;

    window.submitForm = function (trigger, onSuccess, onError) {
        const $form = $(trigger).closest('form');

        // Dev fallback — resolve with empty token if grecaptcha is missing
        const tokenPromise = (typeof grecaptcha !== 'undefined' && grecaptcha.execute)
            ? grecaptcha.execute('6LcNfegsAAAAAJQSsRDERXEo41diyhC8chsNsW_T', {
                action: $form.attr('data-action'),
            })
            : $.Deferred().resolve('').promise();

        tokenPromise.then((token) => {
            const $tokenObj = $form.find('.g-token');
            if ($tokenObj.length > 0) {
                $tokenObj.val(token);
            } else {
                $form.append('<input type="hidden" class="g-token" name="g-recaptcha-response" value="' + token + '">');
            }

            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: new FormData($form[0]),
                processData: false,
                contentType: false,
                dataType: 'json',

                beforeSend: () => {
                    $form.find('input, select, textarea').removeClass('error');
                    $(trigger).addClass('btn--loading');
                },

                complete: () => {
                    $(trigger).removeClass('btn--loading');
                },
            })
                .done((res) => {
                    if (!res.err) {
                        $form.trigger('reset');
                        $form.find("input[type='file']").val('').trigger('change');
                        if (res.msg) { notyf.success(res.msg); }
                        if (onSuccess) { onSuccess(res); }

                        if (res.cart || res.cart === 0) {
                            $('.cart-count').text(res.cart);
                        }

                        if (res.reload) {
                            setTimeout(() => { location.reload(); }, 1000);
                        }

                        if (res.redirect) {
                            setTimeout(() => { location.href = res.redirect; }, 1000);
                        }

                        if (res.target && res.html) {
                            $('.' + res.target).html(res.html);
                        }

                        if (typeof Fancybox !== 'undefined' && Fancybox.getInstance()) {
                            Fancybox.getInstance().close();
                        }
                        return;
                    }

                    notyf.error(res.msg || 'Validation error');
                    if (res.fields && res.fields.length) {
                        res.fields.forEach((field) => {
                            $form.find("[name='" + field + "']").addClass('error');
                        });
                    }
                    if (onError) { onError(res); }
                })
                .fail(() => {
                    if (onError) { onError(); }
                    notyf.error('Something went wrong. Please try again.');
                });
        });
    };

    $(document).on('click', '.js-formSubmit', function (e) {
        e.preventDefault();
        window.submitForm(this);
    });

    // Native form submit (Enter key) — route through submitForm when a .js-formSubmit trigger exists
    $(document).on('submit', 'form', function (e) {
        const $btn = $(this).find('.js-formSubmit').first();
        if (!$btn.length) { return; }
        e.preventDefault();
        if ($btn.hasClass('btn--loading')) { return; }
        window.submitForm($btn[0]);
    });
})(jQuery);
